import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { ENGINE_LANGS } from "@/i18n/languages";
import esCommon from "@/locales/es/common.json";
import enCommon from "@/locales/en/common.json";
import esPublic from "@/locales/es/public.json";
import esShell from "@/locales/es/shell.json";

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

// `common`, `public` y `shell` en es van en estatico: lo demas se pide bajo demanda (i18n/lazyCatalogs.js).
i18n.use(initReactI18next).init({
  lng: "es",
  fallbackLng: "es",
  supportedLngs: ENGINE_LANGS,
  ns: ["common", "engine", "advisors", "public", "auth", "shell", "portfolio", "operations", "analysis", "account", "legal"],
  defaultNS: "common",
  interpolation: { escapeValue: false },
  resources: {
    es: { common: esCommon, public: esPublic, shell: esShell },
    en: { common: enCommon },
  },
});

export default i18n;
